import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FeedbackFormsPageComponent } from './feedback-forms-page.component';
import { AddEditFeedbackFormsModule } from './add-edit-feedback-forms/add-edit-feedback-forms.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.feedbackforms',
    url: '/feedbackforms',
    component: FeedbackFormsPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      feedbackType: null
    }
  }
];

@NgModule({
  declarations: [FeedbackFormsPageComponent],
  imports: [
    CommonModule,
    AddEditFeedbackFormsModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [FeedbackFormsPageComponent],
  entryComponents: [FeedbackFormsPageComponent]
})
export class FeedbackFormsPageModule { }
